
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { CampaignFormValues } from "./types/formTypes";
import ContentEditor from '../ContentEditor';

interface BasicInfoSectionProps {
  form: UseFormReturn<CampaignFormValues>;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ form }) => {
  return (
    <>
      {/* Title Field */}
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Titel</FormLabel>
            <FormControl>
              <Input placeholder="Titel van de modal" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      {/* Content Field with enhanced editor */}
      <FormField
        control={form.control}
        name="content"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Inhoud</FormLabel>
            <FormControl>
              <ContentEditor 
                value={field.value} 
                onChange={field.onChange}
              />
            </FormControl>
            <FormDescription>
              Voeg tekst, afbeeldingen en PDF bestanden toe aan je inhoud.
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default BasicInfoSection;
